<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="d-flex flex-column flex-md-row">
            <div class="col-12 col-md-2 p-0 m-0 mx-0 mx-md-2 my-2 my-md-0">
              <bita-bootbutton
                icon="fas fa-filter"
                type="success"
                class="w-100"
                title="فیلتر بیشتر"
                @click.native="toggleFilters"
              />
            </div>
          </div>
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">

                      <bita-input
                        type="text"
                        name="phone"
                        label="شماره موبایل"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.phone"
                        @change="(e) => search(e)"
                      />

                      <bita-select
                        name="status"
                        label="وضعیت"
                        ref="statusDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="statuses"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.type"
                        @change="(e) => search(e)"
                      />

                      <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-lg-2"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filters.fromDate"
                        @change="(e) => search(e)"
                      />

                      <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-lg-2"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filters.toDate"
                        @change="(e) => search(e)"
                      />

                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "گزارش پیامک ها",
          link: "/sms/report",
          active: true,
        },
      ],
      isLoadingGrid: false,
      filters: {},
      showFilters: false,
      pageSize: 0,
      currentPage: 0,
      statuses: [
        { id: 'sms', name: "پیامک" },
      ],
    };
  },
  mounted() {
    this.readData();
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: "20px" },
        
        {
          field: "full_name",
          title: "نام و نام خانوادگی",
          template: (e) => (e.user ? e.user.full_name : "-"),
          width: "80px",
        },

        {
          field: "phone",
          title: "شماره تماس",
          template: (e) => (e.phone ? e.phone : "-"),
          width: "50px",
        },

        {
          field: "type",
          title: "نوع",
          template: (e) => (e.type ? e.type : "-"),
          width: "40px",
        },

        {
          field: "action",
          title: "فعالیت",
          template: (e) => (e.action ? e.action : "-"),
          width: "60px",
        },
        {
          field: "salon",
          title: "سالن",
          template: (e) => (e.request ? e.request.salon.name : "-"),
          width: "60px",
        },

        {
          field: "origin",
          title: "مبدا",
          template: (e) => (e.request ? `${e.request.origin.province.name} / ${e.request.origin.name}` : "-"),
          width: "60px",
        },

        {
          field: "destination",
          title: "مقصد",
          template: (e) => (e.request ? `${e.request.destination.province.name} / ${e.request.destination.name}` : "-"),
          width: "60px",
        },

        // {
        //   field: "processed_at",
        //   title: "زمان پردازش",
        //   template: (e) =>
        //     e.processed_at
        //       ? this.$getJalaliDateTime(e.processed_at)
        //       : "",
        //   width: "90px",
        // },
        {
          field: "request.created_at",
          title: "تاریخ ایجاد بار",
          template: (e) =>
            e.request
              ? this.$getJalaliDateTime(e.request.created_at)
              : "",
          width: "70px",
        },
        {
          field: "تحویل در",
          title: "",
          template: (e) =>
            e.delivery_at
              ? this.$getJalaliDateTime(e.delivery_at)
              : (e.message_id === 0 ? "لیست سیاه" : ""),
          width: "80px",
        },

        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at
              ? this.$getJalaliDateTime(e.created_at)
              : "",
          width: "100px",
        },

      ];
    },
  },
  methods: {
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `notifications?page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filters = {
          com_profile: 1,
        };
        this.loadData();
        this.resetFilter();
      }
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },
    search: _.debounce(function() {
      this.loadData();
    }, 1000),
  },
};
</script>
<style scoped>
.label {
  font-family: "iranyekan";
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
